

















import PermissionResolver from '@/services/Permissions/PermissionResolver';
import {IEaasiUser} from 'eaasi-admin';
import Vue from 'vue';
import Component from 'vue-class-component';
import {Get} from 'vuex-pathify';
import LeftMenuItem from './LeftMenuItem.vue';
import { IMenuItem } from 'eaasi-nav';
import { ROUTES } from '@/router/routes.const';

@Component({
	components: {
		LeftMenuItem
	}
})
export default class LeftMenu extends Vue {
	@Get('loggedInUser')
	user: IEaasiUser;

	@Get('permissions')
	permit: PermissionResolver;

	userCanManageOrganization() {
		if (!this.user) return false;
		return this.permit.allowsViewManageOrganizationPage();
	}

	get menuItems() : IMenuItem[] {
		let menu = [
			{
				label: 'Dashboard',
				route: ROUTES.DASHBOARD,
			},
			{
				label: 'Explore',
				route: ROUTES.RESOURCES.EXPLORE,
			},
			{
				label: 'My Resources',
				route: ROUTES.RESOURCES.MY_RESOURCES,
			},
			/*{
				label: 'Emulation',
				route: ROUTES.EMULATION_PROJECT.ROOT,
			},*/
			{
				label: 'Import',
				route: ROUTES.IMPORT_RESOURCE,
			}];

		if (this.userCanManageOrganization()) {
			menu.push({
				label: 'Manage Organization',
				route: ROUTES.MANAGE_NODE.ROOT,
			});
		}

		return menu;
	}

	navigateToDashboard() {
		this.$router.push(ROUTES.DASHBOARD);
	}

}

